import { Pie, mixins } from 'vue-chartjs';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ChartData } from 'chart.js';

const { reactiveProp } = mixins;

@Component({
  extends: Pie,
  mixins: [reactiveProp],
})
export default class PsPieChart extends Mixins(reactiveProp, Pie) {
  @Prop() chartData!: ChartData;
  @Prop() options!: object;

  mounted() {
    this.renderChart(this.chartData, this.options);
  }
}
